import {
    HStack,
    Image,
    Link,
    Skeleton,
    SkeletonText,
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Tr,
    VStack
} from "@chakra-ui/react";
import {useQuery} from "@tanstack/react-query";
import {getMineProducer} from "../../../../data/api/Customer";
import {ProducerModelNew} from "../../../../data/model/Producer";
import {scrollbarCss} from "../../../../theme/theme";
import {RecapCard} from "../../../../components/molecules/RecapCard/RecapCard";
import * as React from "react";
import {CategoryIcon, EditIcon, EventIcon, LocationIcon, TaxIcon} from "../../../../components/atoms/SvgImage";
import {EmailIcon, LinkIcon, PhoneIcon} from "@chakra-ui/icons";
import {useNavigate} from "react-router-dom";
import {BaseResponse} from "../../../../data/model/BaseResponse";

export const HomePage = () => {
    const navigate = useNavigate();

    const isAdmin = localStorage.getItem("userType") === 'admin';

    const response = useQuery({queryKey: ["producer_mine"], queryFn: getMineProducer, enabled: !isAdmin})
    const {data, isLoading} = response || {};
    const responseData = data?.data as (BaseResponse<ProducerModelNew>) || {};

    const {data: producer} = responseData || {};

    const {
        name,
        email,
        website,
        images,
        piva,
        address,
        phone,
        description,
        referentName,
        referentSurname,
        referentEmail,
        referentPhone,
        // products_count: productsCount
        // categories_count: categoriesCount,
    } = producer || {};

    const logo = images?.find(data => data.isMain === true) || {};
    const url = logo.url;

    return <VStack w={"100%"}>
        <HStack spacing={"24px"} mt={"24px"} w={"100%"} overflowX={"scroll"}
                css={scrollbarCss({marginLeft: 16, marginRight: 16})}>
            {/*<RecapCard counter={categoriesCount} name={"Categorie"}*/}
            <RecapCard counter={0} name={"Categorie"}
                       h={"184px"}
                       icon={<CategoryIcon strokeColor={"white"} w={"20px"}/>} ms={"24px"}
                       firstButtonClick={() => navigate("/products/category")}
                       secondButtonClick={() => navigate("/products/category/add")}
            />
            <RecapCard name={"Prodotti"}
                       backgroundColor={"tertiary.700"} counter={0}
                       firstButtonClick={() => {
                           navigate("/products");
                       }}
                       h={"184px"}
                       secondButtonClick={() => {
                           navigate("/products/create");
                       }}
            />
            <RecapCard name={"Eventi"} h={"184px"} icon={<EventIcon strokeColor={"white"}/>} backgroundColor={"teal"}
                       me={"24px"}
                       firstButtonClick={() => {
                           navigate("/events");
                       }}/>
        </HStack>

        {isLoading && <HomePageLoading/>}
        {!isLoading && <HStack w={"100%"} h={"100%"} py={"48px"} justifyContent={"center"} alignItems={"center"}
                               spacing={0}>
            <VStack h={"100%"} w={"60%"} overflowY={"auto"} justifyContent={"center"} alignItems={"center"}>
                <Image backgroundColor={"white"} borderRadius={"16px"} objectFit={"cover"}
                       boxShadow={"1px 1px 10px rgba(0,0,0,0.1)"} src={url} h={"144px"}/>
                <Text fontSize={"24px"} mt={"8px"} textColor={"primary.400"} fontWeight={"bold"}>{name}</Text>
                <HStack w={"100%"} justifyContent={"space-evenly"}>
                    <VStack h={"100%"} justifyContent={"space-evenly"}>
                        <HStack>
                            <LocationIcon/>
                            <Link target={"_blank"}
                                  href={`https://www.google.com/maps/search/?api=1&query=${address}`}><Text>{address}</Text></Link>
                        </HStack>
                        <HStack>
                            <LinkIcon/>
                            <Link href={website} target={"_blank"}><Text>{website}</Text></Link>
                        </HStack>
                    </VStack>
                    <TableContainer>
                        <Table>
                            <Tbody>
                                <Tr>
                                    <Td><EmailIcon/></Td>
                                    <Td><Text>{email}</Text></Td>
                                </Tr>
                                <Tr>
                                    <Td><PhoneIcon/></Td>
                                    <Td><Text>{phone}</Text></Td>
                                </Tr>
                                <Tr>
                                    <Td><TaxIcon/></Td>
                                    <Td><Text>{piva}</Text></Td>
                                </Tr>
                            </Tbody>
                        </Table>
                    </TableContainer>
                </HStack>
                <VStack mt={"24px"} px={"36px"} w={"85%"}>
                    <Text fontSize={"20px"} alignSelf={"flex-start"} fontWeight={"bold"}>Descrizione</Text>
                    <Text fontSize={"16px"} textAlign={"justify"}>{description}</Text>
                </VStack>
            </VStack>
            <VStack h={"100%"} w={"35%"} maxW={"50%"} p={"24px"} alignItems={"center"} justifyContent={"center"}
                    spacing={"24px"}>
                <HStack borderRadius={"16px"} w={"100%"} p={"24px"} justifyContent={"center"} spacing={"24px"}
                        cursor={"pointer"} _hover={{backgroundColor: "secondary.200"}} backgroundColor={"tertiary.200"}>
                    <EditIcon/>
                    <Text fontWeight={"bold"}>Modifica informazioni</Text>
                </HStack>

                <VStack borderRadius={"16px"} p={"24px"} justifyContent={"center"}
                        backgroundColor={"surfaceContainer.light"} w={"100%"}>
                    <Text fontSize={"20px"} fontWeight={"bold"} textColor={"primary.400"}>Contatto Referente</Text>
                    <Text textColor={"primary.400"} mb={"16px"} textAlign={"center"}
                          textDecoration={"underline"} textUnderlineOffset={"4px"}
                          fontWeight={"bold"}>{referentName} {referentSurname}</Text>
                    <TableContainer alignSelf={"center"}>
                        <Table>
                            <Tbody>
                                <Tr>
                                    <Td><EmailIcon/></Td>
                                    <Td><Text>{referentEmail}</Text></Td>
                                </Tr>
                                <Tr>
                                    <Td><PhoneIcon/></Td>
                                    <Td><Text>{referentPhone}</Text></Td>
                                </Tr>
                                <Tr>
                                    <Td><TaxIcon/></Td>
                                    <Td><Text>{piva}</Text></Td>
                                </Tr>
                            </Tbody>
                        </Table>
                    </TableContainer>
                </VStack>
                {/*<Image backgroundColor={"white"} borderRadius={"16px"} objectFit={"contain"}*/}
                {/*       boxShadow={"1px 1px 10px rgba(0,0,0,0.1)"} src={logo} w={"50%"}*/}
                {/*       aspectRatio={1}/>*/}
            </VStack>
        </HStack>}
    </VStack>
}

const HomePageLoading = () => {
    return <HStack
        w={"100%"}
        h={"100%"}
        overflow={"hidden"}
        justifyContent={"center"}
        alignItems={"center"}
        spacing={0}>
        <VStack
            h={"100%"}
            w={"60%"}
            overflowY={"hidden"}
            mt={"48px"}
            justifyContent={"center"}
            alignItems={"center"}>
            <Skeleton borderRadius={"24px"} mt={"36px"} w={"144px"} h={"144px"} minH={"144px"}/>
            <Skeleton h={"24px"} w={"30%"} mt={"24px"}/>
            <HStack w={"100%"} justifyContent={"space-evenly"}>
                <TableContainer w={"40%"}>
                    <Table>
                        <Tbody>
                            <Tr>
                                <Td><Skeleton borderRadius={"4px"} w={"24px"} h={"24px"}/></Td>
                                <Td w={"100%"}><Skeleton borderRadius={"6px"} h={"18px"} w={"100%"}/></Td>
                            </Tr>
                            <Tr>
                                <Td><Skeleton borderRadius={"4px"} w={"24px"} h={"24px"}/></Td>
                                <Td w={"100%"}><Skeleton borderRadius={"6px"} h={"18px"} w={"100%"}/></Td>
                            </Tr>
                            <Tr>
                                <Td><Skeleton borderRadius={"4px"} w={"24px"} h={"24px"}/></Td>
                                <Td w={"100%"}><Skeleton borderRadius={"6px"} h={"18px"} w={"100%"}/></Td>
                            </Tr>
                        </Tbody>
                    </Table>
                </TableContainer>
            </HStack>
            <VStack mt={"24px"} px={"36px"} w={"85%"}>
                <Skeleton h={"24px"} w={"20%"} borderRadius={"6px"} alignSelf={"flex-start"} fontWeight={"bold"}/>
                <SkeletonText h={"240px"} w={"100%"} borderRadius={"16px"} skeletonHeight={"24px"} fontSize={"16px"}
                              textAlign={"justify"}/>
            </VStack>
        </VStack>
        <VStack h={"100%"} w={"35%"} maxW={"50%"} p={"24px"} alignItems={"center"} justifyContent={"center"}
                spacing={"24px"}>
            <HStack borderRadius={"16px"} w={"100%"} p={"24px"} justifyContent={"center"} spacing={"24px"}
                    cursor={"pointer"} _hover={{backgroundColor: "secondary.200"}} backgroundColor={"tertiary.200"}>
                <EditIcon/>
                <Text fontWeight={"bold"}>Modifica informazioni</Text>
            </HStack>

            <VStack borderRadius={"16px"} p={"24px"} justifyContent={"center"}
                    backgroundColor={"surfaceContainer.light"} w={"100%"}>
                <Skeleton h={"20px"} borderRadius={"6px"} w={"40%"}/>
                <Skeleton h={"20px"} borderRadius={"6px"} w={"70%"} mb={"16px"}/>
                <TableContainer w={"80%"}>
                    <Table>
                        <Tbody>
                            <Tr>
                                <Td><Skeleton borderRadius={"4px"} w={"24px"} h={"24px"}/></Td>
                                <Td w={"100%"}><Skeleton borderRadius={"6px"} h={"18px"} w={"100%"}/></Td>
                            </Tr>
                            <Tr>
                                <Td><Skeleton borderRadius={"4px"} w={"24px"} h={"24px"}/></Td>
                                <Td w={"100%"}><Skeleton borderRadius={"6px"} h={"18px"} w={"100%"}/></Td>
                            </Tr>
                            <Tr>
                                <Td><Skeleton w={"24px"} borderRadius={"4px"} h={"24px"}/></Td>
                                <Td w={"100%"}><Skeleton h={"18px"} borderRadius={"6px"} w={"100%"}/></Td>
                            </Tr>
                        </Tbody>
                    </Table>
                </TableContainer>
            </VStack>
        </VStack>
    </HStack>
}
